import { NodeRefFullInput, NodeType } from "@graphql";
import { observable } from "mobx";
import { IsNotEmpty } from "class-validator";
import locale from "@bonliva-crm/locale";

type ConsultantData = { Name?: string; _id?: string };

export class OrderCreateData {
  @observable
  @IsNotEmpty({ message: locale.tickets.textRequired })
  title: string = "";

  @observable
  comment: string = "";

  @observable
  date: Date | null = null;

  @observable
  assignedTeam: string | null = null;

  @observable
  consultant: NodeRefFullInput = null;

  @observable
  project: string | null = null;

  @observable
  projectInfo: string | null = null;

  @observable
  dueDateReason: string | null = null;

  @observable
  place: string | null = null;

  static Empty() {
    return new OrderCreateData();
  }

  private commonData(consultant: ConsultantData) {
    this.assignedTeam = "QualityDepartment";
    this.consultant = {
      Name: consultant.Name,
      NodeID: consultant._id,
      NodeType: NodeType.Consultant
    };
  }

  private handleHLR(name: string) {
    this.title = `Beställning av ${name}`;
    this.place = "";
    this.project = "";
  }

  static ByQualificationName(consultant: ConsultantData, name: string) {
    const data = new OrderCreateData();

    data.commonData(consultant);

    data.handleHLR(name);

    return data;
  }
}
